import { InlineGrid, BlockStack, Text, Card, Button, Box } from '@shopify/polaris';
import { Link } from "react-router-dom";

const FeatureCard = ({ title, description, buttonText, linkUrl, image, showImage, stripeBackground }) => {
  return(
    <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
      <Box
        as="section"
        paddingInlineStart={{ xs: 400, sm: 0 }}
        paddingInlineEnd={{ xs: 400, sm: 0 }}
      >
        <BlockStack gap="400">
          <Text as="h3" variant="headingMd">
            {title}
          </Text>
          
        </BlockStack>
      </Box>
      <Link to={linkUrl + window.location.search} className="no-style">
        <Card roundedAbove="sm">
          <BlockStack gap="400">    
            <Text as="p" variant="bodyMd">
              {description}
            </Text>

            <Button icon={image}>{buttonText}</Button>
          </BlockStack>
        </Card>
      </Link>
    </InlineGrid>
  )
}

export default FeatureCard;
